import React from "react";
import "../../assets/css/loader.css";

const ButtonLoader = () => {
  return (
    <div className="btn_loader">
      <div className="dot-pulse"></div>
    </div>
  );
};

export default ButtonLoader;

